import { render, staticRenderFns } from "./DuplicateIpnConflicts.vue?vue&type=template&id=4bfbab86&scoped=true&"
import script from "./DuplicateIpnConflicts.vue?vue&type=script&lang=js&"
export * from "./DuplicateIpnConflicts.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateIpnConflicts.vue?vue&type=style&index=0&id=4bfbab86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfbab86",
  null
  
)

export default component.exports